<template>
  <v-layout id="split-details-container" class="panel details-panel" row wrap>
    <v-flex xs12 md12 class="timeline-header">
      <v-icon>mdi-source-fork</v-icon>
      RECEBEDORES / {{ transaction.payables.length }}
    </v-flex>
    <div class="split-main-sidebar paid"></div>
    <div class="split-amount-wrapper paid">
      <p class="split-total-amount">
        <span>R$</span>{{ (transaction.amount / 100) | formatCurrency }}
      </p>
      <p class="split-installment">parcelado em <span>1x</span></p>
    </div>
    <div class="col-xs-11 recipient-wrapper">
      <div class="split-sidebar paid"></div>
      <div class="split-percentage paid">
        28
        <span>%</span>
      </div>
      <div class="split-data-container paid">
        <div class="split-data-header paid">
          <p class="split-name">
            <v-icon color="white">mdi-briefcase</v-icon> Enercredweb Sistemas
            Ltda
          </p>
          <!-- <p class="split-document-number">
                        <span>CNPJ</span> 27.295.080/0001-06
                    </p> -->
        </div>
        <v-layout class="split-data-body" row wrap>
          <v-flex sm1 md1 class="split-index last-left"> 1 </v-flex>
          <v-flex sm4 md4 class="split-amount"> R$51,06 </v-flex>
          <v-flex sm3 md3 class="split-date">
            <p>08/10/2019</p>
            <span>R$2,52</span>
          </v-flex>
          <v-flex sm4 md4 class="split-liquid"> R$48,54 </v-flex>
        </v-layout>
      </div>
    </div>
    <div class="col-xs-11 recipient-wrapper">
      <div class="split-sidebar paid"></div>
      <div class="split-percentage paid">
        72
        <span>%</span>
      </div>
      <div class="split-data-container paid">
        <div class="split-data-header paid">
          <p class="split-name">
            <v-icon color="white">mdi-briefcase</v-icon> Safira Trading de
            Energia Ltda
          </p>
          <!-- <p class="split-document-number">
                        <span>CNPJ</span> 27.295.080/0001-06
                    </p> -->
        </div>
        <v-layout class="split-data-body" row wrap>
          <v-flex sm1 md1 class="split-index last-left"> 1 </v-flex>
          <v-flex sm4 md4 class="split-amount"> R$51,06 </v-flex>
          <v-flex sm3 md3 class="split-date">
            <p>08/10/2019</p>
            <span>R$2,52</span>
          </v-flex>
          <v-flex sm4 md4 class="split-liquid"> R$48,54 </v-flex>
        </v-layout>
      </div>
    </div>
  </v-layout>
</template>
<script>
import { EventBus } from "../../utils/event-bus";
export default {
  props: ["transaction_id"],
  data: () => ({
    transaction: {},
  }),
  created() {},
  mounted() {
    EventBus.$on("transaction", (transaction) => {
      // console.log('LoadInvoices: ', invoices)
      this.transaction = transaction;
    });
  },
};
</script>
<style scoped>
p {
  font-size: 22px !important;
}

#split-details-container {
  position: relative;
  padding-bottom: 0;
}

#split-details-container .split-main-sidebar {
  position: absolute;
  left: 50px;
  top: 114px;
  bottom: 200px;
  width: 2px;
  border: none;
}

.split-amount-wrapper {
  color: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 8px;
  margin-bottom: 45px;
  padding: 15px 20px;
  display: inline-block;
}

.split-installment {
  font-style: italic;
  font-size: 25px;
}

.split-amount-wrapper p {
  margin: 0;
  font-size: 24px;
  text-align: center;
}

.split-total-amount {
  font-size: 24px;
  font-weight: bold;
  line-height: 21px;
}

.border-status.paid,
#split-details-container .recipient-wrapper .paid.split-sidebar {
  border-color: #3cb880;
}

.border-status.paid,
#split-details-container #payables-details-container .paid.payable-data-body,
#split-details-container .paid.split-data-container {
  border-color: #3cb880;
  background: #fff;
}

#split-details-container .recipient-wrapper {
  padding: 0;
  position: relative;
  margin-bottom: 50px;
}

.col-xs-11 {
  width: 91.66667%;
}

.col-xs-12,
.col-xs-11,
.col-xs-10,
.col-xs-9,
.col-xs-8,
.col-xs-7,
.col-xs-6,
.col-xs-5,
.col-xs-4,
.col-xs-3,
.col-xs-2,
.col-xs-1 {
  float: left;
}

#split-details-container .recipient-wrapper .split-sidebar {
  position: absolute;
  border-bottom: 2px solid #ffffff;
  border-left: 2px solid #ffffff;
  border-bottom-left-radius: 30px;
  width: 50%;
  height: 50%;
  left: 0px;
  bottom: 100%;
  transform: translateY(26px);
  -webkit-transform: translateY(26px);
  -moz-transform: translateY(26px);
  -ms-transform: translateY(26px);
}

#split-details-container .recipient-wrapper .split-percentage {
  padding: 10px 0;
  display: inline-block;
  border-radius: 5px;
  font-weight: bold;
  font-size: 17px;
  position: relative;
  left: 45px;
  float: left;
  text-align: center;
  width: 100px;
}

#split-details-container .split-data-container .split-data-header {
  padding: 10px 15px;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  position: relative;
}

#split-details-container .split-data-container .split-data-header p.split-name {
  font-size: 18px !important;
  color: #fff;
  font-weight: 400;
}

#split-details-container .split-data-container .split-data-header p {
  margin: 0;
  display: inline-block;
  transition: all 0.2s ease-out;
  cursor: pointer;
}

.border-status.paid,
#split-details-container .recipient-wrapper .paid.split-sidebar,
#payables-details-container .paid.payable-data-body,
#split-details-container .paid.split-data-container {
  border-color: #3cb880;
}

.background-status.paid,
.detail-object > .value > span.paid.ss-icon,
#split-details-container .paid.split-main-sidebar,
#split-details-container .paid.split-amount-wrapper,
#split-details-container .recipient-wrapper .paid.split-percentage,
#payables-details-container
  .payable-data-body
  .payable-data-row
  div.payable-date
  .anticipation-arrow
  .paid.arrow-body,
#split-details-container .split-data-container .paid.split-data-header,
#split-details-container
  .split-data-container
  .split-data-body
  .split-data-row
  div.split-date
  .anticipation-arrow
  .paid.arrow-body {
  background-color: #3cb880;
  border-color: #3cb880;
  color: #fff;
}

.last-left {
  border-bottom-left-radius: 6px;
}

.split-index {
  /* width: 10%; */
  text-align: center;
  /* background-color: #d3d3d3; */
  color: #6c6c6c;
  font-size: 18px;
  float: left;
  text-align: center;
  font-weight: bold;
}

.split-amount {
  text-align: center;
  /* background-color: #e4e2e2; */
  color: #6c6c6c;
  width: 23%;
  float: left;
  /* height: 80px; */
  font-size: 18px !important;
  font-weight: bold;
}

.split-date {
  text-align: left;
  /* background-color: #e4e2e2; */
  color: #6c6c6c;
  width: 23%;
  float: left;
  /* height: 98px; */
}

.split-date p {
  font-size: 18px !important;
  font-weight: bold;
  color: #6c6c6c;
}

.split-date span {
  font-size: 15px !important;
  color: #606060;
}

.split-liquid {
  text-align: center;
  /* background-color: #e4e2e2; */
  color: #6c6c6c;
  width: 23%;
  float: left;
  /* height: 98px; */
  font-weight: bold;
  font-size: 25px !important;
}

#split-details-container .split-data-container {
  display: inline-block;
  position: relative;
  border-radius: 8px;
  width: 75%;
  left: 90px;
  border: 2px solid #ffffff;
}

#split-details-container .split-data-container .split-data-header {
  padding: 10px 15px;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  position: relative;
}

#split-details-container .split-amount-wrapper p {
  margin: 0;
  text-align: center;
}

#split-details-container .paid.split-amount-wrapper {
  background-color: #3cb880;
  border-color: #3cb880;
}

#split-details-container .split-amount-wrapper {
  border-radius: 8px;
  margin-bottom: 45px;
  padding: 15px 20px;
  display: inline-block;
}

.details-panel {
  background-color: transparent;
  overflow: hidden;
}

.panel {
  margin-bottom: 22px;
  /* background-color: #fff; */
  border: 1px solid transparent;
  border-radius: 3px;
}

.details-panel.flip-panel {
  -webkit-perspective: 1000px;
  perspective: 1000px;
  position: relative;
}
@media screen and (min-width: 1200px) {
  .details-main .flip-panel {
    min-height: 440px;
  }
  .details-panel {
    /* background-color: transparent; */
    overflow: hidden;
  }
  .panel {
    margin-bottom: 22px;
    /* background-color: #fff; */
    border: 1px solid transparent;
    border-radius: 3px;
    padding-top: 20px;
    padding-left: 50px;
  }
}

.details-panel.purchase_detail {
  background-color: #fff;
  padding-top: 20px;
  padding-left: 20px;
}

.details-panel.purchase_detail .bloco {
  /* background-color: #FFF; */
  padding: 10px;
  margin-bottom: 22px;
  /* background-color: #fff; */
  border: 1px solid transparent;
  border-radius: 5px;
  padding-top: 20px;
  padding-left: 20px;
  background: #e2e2e2;
}

.details-panel .venc {
  font-size: 12px;
  border-bottom: 1px solid #cccccc;
}

.details-panel .venc_data {
  font-size: 12px;
  color: #cccccc;
}

.detail-object {
  padding: 0;
  margin-bottom: 20px;
}

.detail-object.boleto .title {
  font-size: 13px;
  width: 40%;
}
.detail-object > .title {
  color: #b0b0b0;
  font-style: italic;
  font-weight: 500;
  font-size: 14px;
  width: 80%;
  border-bottom: 1px solid #e2e2e2;
}
.detail-object > div {
  padding-left: 0px;
}

.detail-object.boleto .value {
  font-size: 16px;
  font-weight: 600;
  margin-top: 4px;
  opacity: 0.74;
}
.detail-object > .value:not(img) {
  height: 28px;
}
.detail-object > .value {
  color: #828282;
  font-size: 20px;
  word-wrap: break-word;
  margin-top: 8px;
}

.detail-object.status-url .value.paid {
  color: #3cb880;
}
</style>
